import React from 'react';

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <mask id="mask0_22_5195" style={{ maskType: 'alpha' }} width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse">
        <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
      </mask>
      <g mask="url(#mask0_22_5195)">
        <path
          fill="#1D252D"
          d="M10.317 17.41l-2.029-2.03a.75.75 0 01-.227-.537.732.732 0 01.227-.547.743.743 0 01.543-.232c.206 0 .387.077.542.232l1.577 1.577 3.677-3.677a.75.75 0 01.537-.228.732.732 0 01.547.228.743.743 0 01.233.543.743.743 0 01-.233.542l-4.128 4.129a.867.867 0 01-.633.27.867.867 0 01-.633-.27zm-5.01 4.148c-.504 0-.932-.175-1.282-.525A1.745 1.745 0 013.5 19.75V6.365c0-.505.175-.932.525-1.282.35-.35.778-.525 1.283-.525h1.384V3.212c0-.22.074-.403.22-.55a.745.745 0 01.55-.22c.219 0 .402.074.549.22.146.147.22.33.22.55v1.346h7.577V3.192c0-.212.071-.39.215-.534a.726.726 0 01.535-.216c.212 0 .39.072.534.216a.726.726 0 01.216.534v1.366h1.384c.505 0 .933.175 1.283.525.35.35.525.777.525 1.282V19.75c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H5.308zm0-1.5h13.385a.3.3 0 00.221-.087.3.3 0 00.087-.221v-9.384H5v9.384a.3.3 0 00.087.221.3.3 0 00.22.087zM5 8.865h14v-2.5a.3.3 0 00-.087-.22.3.3 0 00-.22-.087H5.307a.3.3 0 00-.221.086.3.3 0 00-.087.221v2.5z"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
